export const SEARCH_COMPANIES_DATA = "SEARCH_COMPANIES_DATA";
export const RESET_ACTION = "RESET_ACTION";
